import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';
import { RoutePathPayload } from './route.state';

@Injectable({
  providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class RouteActions {
  static setRouteAndPath = createAction('[Route] Set Route Path', props<RoutePathPayload>());
}
